// Файл AppErrorBoundary.js

/**
 * Компонент перехватывает необработанные ошибки React, журналирует их и запускает безопасное восстановление интерфейса.
 */

import React from 'react';

import { recover_frontend_once } from '../utils/frontend_recovery';
import { log_frontend_error } from '../utils/frontend_logger';
import './AppErrorBoundary.css';



class AppErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        console.error('Критическая ошибка интерфейса:', error, info);
        log_frontend_error('react_error_boundary', error, {
            component_stack: info?.componentStack || '',
        });
        recover_frontend_once(error);
    }

    render() {
        if (!this.state.error) {
            return this.props.children;
        }

        return (
            <main className="app-error-boundary grid-layout">
                <h1>Интерфейс не загрузился</h1>
                <p>
                    Данные не потеряны. Обновите страницу и повторите действие.
                </p>
                <button type="button" onClick={() => window.location.reload()}>
                    Обновить страницу
                </button>
            </main>
        );
    }
}

export default AppErrorBoundary;
